import { render } from "./EventAlertNotificationCard.vue?vue&type=template&id=7c20323b&scoped=true"
import script from "./EventAlertNotificationCard.vue?vue&type=script&lang=js"
export * from "./EventAlertNotificationCard.vue?vue&type=script&lang=js"

import "./EventAlertNotificationCard.vue?vue&type=style&index=0&id=7c20323b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c20323b"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QExpansionItem,QBadge,QIcon,QBtn,QCardSection,QBanner,QSpinner,QSpace});
